import React, { useCallback, useEffect, useState } from "react";
import { Typography, CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { COINBASE, METAMASK, WALLETCONNECT } from "../../../utils/wallet";

import OutlinedButton from "../../Buttons/OutlinedButton";
import { setNotification } from "../../../redux/slices/notifications";
import {
  bind,
  bindChallenge,
  isBound,
  setSelectedWallet,
  setIsLoading,
  WALLET_CONNECTION_TYPES
} from "../../../redux/slices/wallet";
import { setAccountNotification } from "../../../redux/slices/accountNotifications";
import { isWalletBrowser } from "../../../utils/isMobile";
import bs58 from "bs58";

function WalletLogin({ closeDialog, wallet }) {
  const { name, hook, connector, Icon } = wallet;
  const dispatch = useDispatch();
  const { isLoading, connectionType } = useSelector((state) => state.wallet);
  const { user } = useSelector((state) => state.auth);
  // const { useAccounts, useIsActive, useProvider } = hook;
  // const accounts = useAccounts();
  // const isActive = useIsActive();
  // const provider = useProvider();
  // const signer = provider?.getSigner();
  const [activated, setActivated] = useState(false);
  const [isSolanaActive, setIsSolanaActive] = useState(false);
  const [walletAddress, setWalletAddress] = useState(null);

  // useEffect(() => {
  //   const checkPhantomConnection = async () => {
  //     const { solana } = window;
  //     if (solana && solana.isPhantom) {
  //       try {
  //         const response = await solana.connect();
  //         setWalletAddress(response.publicKey.toString());
  //         setIsSolanaActive(true);
  //       } catch (error) {
  //         console.error("Error checking Phantom Wallet connection:", error);
  //       }
  //     }
  //   };

  //   checkPhantomConnection();
  // }, []);

  const connectPhantomWallet = async () => {
    try {
      const { solana } = window;
      if (solana && solana.isPhantom) {
        const response = await solana.connect();
        const address = response.publicKey.toString();
        setWalletAddress(address);
        setIsSolanaActive(true);
        return address;
      } else {
        alert("Phantom Wallet not found. Please install it.");
      }
    } catch (error) {
      console.error("Error connecting to Phantom Wallet:", error);
    }
  };
  const signMessage = async (message) => {
    try {
      const { solana } = window;
      if (solana && solana.isPhantom) {
        const encodedMessage = new TextEncoder().encode(message);
        const signedMessage = await solana.signMessage(encodedMessage, "utf8");
        const signatureString = bs58.encode(signedMessage.signature);
        return signatureString;
      } else {
        throw new Error("Phantom Wallet not found. Please install it.");
      }
    } catch (error) {
      console.error("Error signing message with Phantom Wallet:", error);
      return null;
    }
  };

  const login = useCallback(async () => {
    try {
      const address = await connectPhantomWallet();

      dispatch(isBound({ walletAddress: address })).then((isBoundRes) => {
        if (isBoundRes) {
          closeDialog();
          dispatch(
            setAccountNotification({
              message: "This wallet is already associated with an existing account."
            })
          );
        } else {
          dispatch(bindChallenge({ email: user?.email, walletAddress: address })).then(
            async (bindChallengeRes) => {
              const signature = await signMessage(bindChallengeRes.message);
              if (signature) {
                dispatch(bind({ walletAddress: address, signature }))
                  .then((response) => {
                    if (response) {
                      closeDialog();
                      dispatch(
                        setAccountNotification({
                          message: "Wallet successfully bound to your account."
                        })
                      );
                    }
                  })
                  .catch((error) => {
                    dispatch(setIsLoading(false));
                    closeDialog();
                    dispatch(setAccountNotification({ code: 4001 }));
                  });
              }
            }
          );
        }
      });
    } catch (error) {
      console.error("Error connecting to Solana wallet:", error);
    }
  }, [closeDialog, dispatch, user?.email, walletAddress]);

  // useEffect(() => {
  //   if (isSolanaActive && connectionType === WALLET_CONNECTION_TYPES.bind) {
  //     login();
  //   } else if (isSolanaActive && connectionType === WALLET_CONNECTION_TYPES.connect) closeDialog();
  // }, [closeDialog, connectionType, isSolanaActive, login]);

  return (
    <Box my={2} display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" flexWrap="nowrap" alignItems="center">
        <Icon />
        <Typography sx={{ ml: 2, textTransform: "capitalize", fontSize: "14px" }}>
          {wallet.name}
        </Typography>
      </Box>

      <OutlinedButton
        disabled={isLoading}
        label={activated ? <CircularProgress color="primary" size={8} /> : "connect"}
        classname="augmented-button-primary"
        color="primary"
        handleClick={() => login()}
        sx={{
          height: "28px",
          width: "75px",
          fontWeight: "normal",
          backgroundImage: "none",
          color: "text.secondary",
          fontSize: "12px"
        }}
      />
    </Box>
  );
}

export default WalletLogin;
